const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}



/** mt-image-selector **/
Array.from(document.querySelectorAll(".mt-image-selector__wrapper")).forEach((container) => {
    var selectors = container.querySelectorAll(".mt-image-selector__selector");
    var itemSelects = Array.from(container.querySelectorAll(".mt-image-selector__item"));
  
    selectors.forEach((selector) => {
      selector.addEventListener('click', (e) => {
        selectors.forEach((item) => {
          item.classList.remove("selected");
        });
        e.target.classList.add("selected");
        var val = parseInt(e.target.getAttribute("data-val"));
        itemSelects.forEach((item) => {
          var curVal = parseInt(item.getAttribute("data-val"));
          if(val == curVal){
            item.classList.remove("unshow");
          }else{
            item.classList.add("unshow");
          }     
        });
      });
    });
});
/** mt-image-selector **/

/** mt-text-selector **/
Array.from(document.querySelectorAll(".mt-text-selector__wrapper")).forEach((container) => {
    var selectors = container.querySelectorAll(".mt-text-selector__selector");
    var itemSelects = Array.from(container.querySelectorAll(".mt-text-selector__item"));
    selectors.forEach((selector) => {
      selector.addEventListener('click', (e) => {
        selectors.forEach((item) => {
          item.classList.remove("selected");
        });
        e.target.classList.add("selected");
        var val = parseInt(e.target.getAttribute("data-val"));
        itemSelects.forEach((item) => {
          var curVal = parseInt(item.getAttribute("data-val"));
          if(val == curVal){
            item.classList.remove("hidden");
            item.classList.remove("unshow");
          }else{
            item.classList.add("hidden");
            item.classList.add("unshow");
          }     
        });
      });
    });
});
/** mt-text-selector **/

/** mt-image-text-icons **/
Array.from(document.querySelectorAll(".mt-image-text-icons__wrapper")).forEach((container) => {
    var selectors = container.querySelectorAll(".mt-image-text-icons__dot");
    var itemSelects = Array.from(container.querySelectorAll(".mt-image-text-icons__image"));
  
    selectors.forEach((selector) => {
      selector.addEventListener('click', (e) => {
        selectors.forEach((item) => {
          item.classList.remove("selected");
        });
        e.target.classList.add("selected");
        var val = parseInt(e.target.getAttribute("data-val"));
        itemSelects.forEach((item) => {
          var curVal = parseInt(item.getAttribute("data-val"));
          if(val == curVal){
            item.classList.add("blur_show");
          }else{
            item.classList.remove("blur_show");
          }     
        });
      });
    });
});
Array.from(document.querySelectorAll(".mt-image-text-icons__wrapper")).forEach((container) => {
    var selectors = container.querySelectorAll(".mt-image-text-icons__icon-item");
    selectors.forEach((selector) => {
      selector.addEventListener('click', (e) => {
        selectors.forEach((item) => {
          item.querySelector(".mt-image-text-icons__arrow").classList.remove("selected");
        });
        selector.querySelector(".mt-image-text-icons__arrow").classList.add("selected");
        var val = parseInt(selector.querySelector(".mt-image-text-icons__arrow").getAttribute("data-val"));
        Array.from(container.querySelectorAll(".mt-image-text-icons__icon-detail")).forEach((item) => {
          var curVal = parseInt(item.getAttribute("data-val"));
          if(val == curVal){
            item.classList.toggle("scale0");
          }else{   
            item.classList.add("scale0");
          }     
        });
      });
    });
});
/** mt-image-text-icons **/

/** mt-video-list **/
Array.from(document.querySelectorAll(".mt-video-list_container")).forEach((container) => {
    let btns = container.querySelector(".slider-buttons");
    let isClicked = false;
    let maxWidth = container.querySelector(".mt-video-list-wrapper").getBoundingClientRect().left + container.querySelector(".mt-video-list-wrapper").getBoundingClientRect().width + 200;
    btns.querySelector(".slider-button--prev").addEventListener('click', (e) => {
        if(isClicked) return;
        isClicked = true;
        let val = parseInt(btns.getAttribute("data-val"));
        if(val > 1){
          val = parseInt(val) - 1;
          selectContent(val);
        }else{
          isClicked = false;
        }
    });
    btns.querySelector(".slider-button--next").addEventListener('click', (e) => {
        if(isClicked) return;
        isClicked = true;t
        let val = parseInt(btns.getAttribute("data-val"));
        let maxVal = parseInt(btns.getAttribute("data-max-val"));
        let width = itemSelects[itemSelects.length -1].getBoundingClientRect().width + itemSelects[itemSelects.length -1].getBoundingClientRect().left;
        if(val < maxVal && width > maxWidth){
          val = val + 1;
          console.log("max-width:" + maxWidth + ", width:" + width + ", item_width:" + itemSelects[itemSelects.length -1].getBoundingClientRect().width + ", item_left:" + itemSelects[itemSelects.length -1].getBoundingClientRect().left);
          selectContent(val);
        }else{
          isClicked = false;
        }
    });
    let itemSelects = Array.from(container.querySelectorAll(".mt-video-list-item"));
    let firstLeft = itemSelects[0].offsetLeft;
    let leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;  
    function selectContent(val){ 
      let moveX = 0;
      if(itemSelects != null && itemSelects.length > 1){
        moveX = firstLeft - leftX * (val - 1);
      }
      itemSelects.forEach((itemItem) => {
        container.querySelector(".mt-video-list-wrapper").style.marginLeft = moveX + "px";
        console.log("leftX:" + leftX + ",val:" + val);
      });
      btns.setAttribute("data-val", val);
      isClicked = false;
    }
});
/** mt-video-list **/

/** footer **/
Array.from(document.querySelectorAll(".footer")).forEach((container) => {
    let selectors = container.querySelectorAll(".footer-block");
    selectors.forEach((selector) => {
      selector.addEventListener('click', (e) => {
        selector.classList.toggle("selected");
      });
    });
  
});
/** footer **/

if(document.querySelector(".menu-drawer-container") != null){
  Array.from(document.querySelectorAll(".menu-drawer-container")).forEach((container) => {
    container.querySelector(".menu-drawer__header-icon .icon-close").addEventListener('click', (e) => {
        container.querySelector(".header__icon--menu").click();
    });
  });
}